import StopStates from './styled';

export default StopStates;
